export const CSV_FILE_FORMAT = '.csv';
export const FILE_IS_TOO_BIG_MSG = 'File is too big (up to 10MB).';
export const POP_UP_MSG = 'Start by uploading a single column CSV file with the new URLs.';
